import { useEffect, useState } from 'react';
import { API, publicApi } from '@/lib/api';
import { langFromCountry } from '@/lib/checkoutI18n';

// One-shot, best-effort IP → language. Used ONLY as a fallback when the store
// has no fixed language (Personnalisation). Returns '' until resolved and on
// failure, so the caller's own fallbacks (browser, French) still apply.
export function useGeoLang() {
  const [lang, setLang] = useState('');
  useEffect(() => {
    let alive = true;
    publicApi.get(`${API}/public/geo`)
      .then((r) => { if (alive) setLang(langFromCountry(r.data?.country)); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return lang;
}
